import type {PageRouteConfig} from '@router';

import ProList from 'modules/Services/PromotionCenter/Pro/List/ProList';
import {routes} from 'routes/routes';

export function createPromotionCenterProListRoute(): PageRouteConfig {
  return {
    element: <ProList />,
    layout: {
      title: 'پرو',
      hasNavigate: false,
      hasHeader: true,
      hasBack: true,
      hasLeftIcon: false,
      link: routes.PROMOTION_CENTER
    }
  };
}
